<template>
  <div>
    <el-table
      class="table-responsive table-flush mt-6 h-400"
      header-row-class-name="thead-light table-th-color"
      :data="TableTagsData"
    >
      <el-table-column
        label="Order ID "
        prop="transID"
        min-width="150px"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.transID }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Amount" min-width="140px" prop="amount" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.amount }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Date" min-width="140px" prop="date" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Status" min-width="150px" prop="status" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.status }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
// import "../../scss/Index.scss";
// import TagsData from "./TagsData";

import TableTagsData from "./TableTagsData";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  props: {
    selectedName: String
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      TableTagsData,
      currentPage: 1,
      editModal: false,
      titleModal: false,
      openAddBannerSidebar: false
    };
  },
  // computed: {
  //   tableData() {
  //     return this.TagsData.filter(x => x.vendorname === this.selectedName);
  //   }
  // },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
